export default __webpack_public_path__ + "static/media/alvin.8da803d3.png";